@if (visible) {
  <div class="survey-banner">
    <div class="background-wrapper">
      <div class="wrapper">
        <div class="content">
          <span class="title" [innerHTML]="title" margin-bottom-medium></span>
          <span class="description">{{ description }}</span>
          <a rt-button variant="tellent" target="_blank" [href]="link" class="start-button">
            <span
              >{{ buttonText }}
              <div class="button-text-suffix">{{ buttonTextSuffix }}</div></span
            >
            <rt-icon name="arrow-forward"></rt-icon>
          </a>
        </div>
        <rt-icon-button
          (click)="markAsHidden()"
          variant="transparent-dark"
          iconName="close"
          margin-top-small-x
          margin-right-small-x
        >
        </rt-icon-button>
      </div>
    </div>
  </div>
}
